/**
 * Landlock Game Balance Configuration
 * 모든 게임 밸런스 수치를 한 곳에서 관리
 * docs/balance.md 참조
 */

export const GAME_CONSTANTS = {
  // === MOVEMENT ===
  movement: {
    baseSpeed: 200,                    // px/sec
    drillReductionFactor: 0.7,         // 층당 30% 감속
  },

  // === LIVES ===
  lives: {
    initial: 3,
    max: 5,
    respawnInvincibilityMs: 3000,      // 3초
  },

  // === SCORING ===
  scoring: {
    // Tile scores by layer (index = layer level)
    tileScores: [0, 1, 3, 6, 10, 15],

    // Kill bonuses
    killBonus: 50,
    highLayerKillBonus: 30,
    highLayerThreshold: 3,

    // Streak
    streakMultiplier: 1.5,
    streakTimeoutMs: 10000,

    // Conquest
    enemyTerritoryMultiplier: 1.5,
    largeConquestThreshold: 20,
    largeConquestBonus: 0.1,
  },

  // === MAP ===
  map: {
    defaultWidth: 100,
    defaultHeight: 100,
    minSize: 50,
    maxSize: 200,
    spawnMargin: 10,
    spawnSafeRadius: 5,
    tileSize: 32,                      // px
  },

  // === LAYERING ===
  layering: {
    maxLevel: 5,
    minTilesForUpgrade: 4,
  },

  // === TIMING ===
  timing: {
    defaultGameDuration: 180,
    minGameDuration: 60,
    maxGameDuration: 600,
    countdownSeconds: 3,
    endGameDelay: 5,
  },

  // === NETWORK ===
  network: {
    positionBroadcastInterval: 50,     // ms (~20Hz) - 실시간 플레이어 이동 동기화
    botPositionBroadcastInterval: 100, // ms (10Hz) - 봇 위치 동기화 (호스트 전용)
    botTrailBroadcastEvery: 2,         // 봇 위치 N회당 1회만 trail 포함 (10Hz / 2 = 5Hz)
    positionInterpolation: 80,         // ms
    maxLatencyCompensation: 300,       // ms
    remoteStaleTimeout: 4000,          // ms - 일시적 네트워크 끊김에 바로 지우지 않도록 여유
    disconnectTimeout: 10000,          // ms
  },

  // === ROOM ===
  room: {
    defaultMaxPlayers: 8,
    minMaxPlayers: 2,
    maxMaxPlayers: 16,
    minPlayersToStart: 2,
    idleTimeout: 300,
  },

  // === COLORS (from ui_design.md) ===
  colors: {
    players: [
      '#FF6B9D',  // Rose Pink
      '#45B7D1',  // Sky Blue
      '#96E6A1',  // Mint Green
      '#DDA0DD',  // Plum
      '#F7DC6F',  // Soft Gold
      '#BB8FCE',  // Soft Purple
      '#85C1E9',  // Light Blue
      '#F8B500',  // Amber
      '#58D68D',  // Emerald
      '#EC7063',  // Coral Red
      '#AF7AC5',  // Orchid
      '#48C9B0',  // Turquoise
    ],
    background: '#F7F9FC',
    gridLines: '#E0E6ED',
    neutralTile: '#FFFFFF',
    textPrimary: '#2C3E50',
    textSecondary: '#95A5A6',
    danger: '#FF4757',
    success: '#2ED573',
  },
} as const;

// Type exports for type safety
export type GameConstants = typeof GAME_CONSTANTS;
